import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ParRegion from './par-region';
import ParRegionDetail from './par-region-detail';
import ParRegionUpdate from './par-region-update';
import ParRegionDeleteDialog from './par-region-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ParRegionUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ParRegionUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ParRegionDetail} />
      <ErrorBoundaryRoute path={match.url} component={ParRegion} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ParRegionDeleteDialog} />
  </>
);

export default Routes;
